import { range } from '../../utils/Arr';

export const deadlineDropdownOptions = [
    15,
    30,
    ...range(10, true).map((hours) => hours * 60),
].map((value) => {
    const label =
        value >= 60
            ? `${value / 60} ${value === 60 ? 'time' : 'timer'}`
            : `${value} min.`;

    return [value, label + ' før start'];
});

export const persistence = (storeKey) => ({
    get: (defaults) => {
        const item = window.localStorage.getItem(storeKey);
        return item === null ? defaults : JSON.parse(item);
    },
    key: storeKey,
});
